// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'

// interface
interface Props {
    content?: string
    className?: string
    after?: React.ReactNode
}

export default function RichTextSection({
    content,
    className,
    after
}: Props) {
    return (
        <Section
            className={className}
            paddingTop='medium'
            paddingBottom='medium'
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2'>
                        <RichText content={content} />

                        {/* This after is an example of macros in the content - For prototype purposes */}
                        {after}
                    </div>
                </div>
            </div>
        </Section>
    )
}